import { config as platformConfig } from '@shopee-user/platform';
import { monitor } from '../../../platform/monitoring';
import { BusinessPerfMetric } from '../../../platform/monitoring/performance/enums';
import type { LoginFromSource } from '@tob/shared/post-authentication/enums';
import {
  Status,
  BusinessPage,
  LoginMethod,
  SignupMethod,
  AccType,
  PostAuthUnexpectedBehaviorReason,
} from './enums';

export function sendLoginResult(data: {
  status: Status;
  login_method: LoginMethod;
  business_page: BusinessPage;
  acc_type: AccType;
  error?: number;
  api_source?: string;
  reason?: string;
}) {
  monitor.sendAccumulate({
    name: BusinessPerfMetric.LoginResult,
    data: { ...data, business_target: platformConfig.BUSINESS_TARGET },
  });
}

export function sendSignupResult(data: {
  status: Status;
  signup_method: SignupMethod;
  business_page: BusinessPage;
  acc_type: AccType;
  error?: number;
  api_source?: string;
}) {
  monitor.sendAccumulate({
    name: BusinessPerfMetric.SignupResult,
    data: { ...data, business_target: platformConfig.BUSINESS_TARGET },
  });
}

export function sendPostAuthenticationUnexpectedBehavior(data: {
  reason: PostAuthUnexpectedBehaviorReason;
  processor?: string;
  source: LoginFromSource;
  error?: number;
  apiSource?: string;
  isToBAccountInContext?: boolean;
  isToCAccountInContext?: boolean;
}) {
  monitor.sendAccumulate({
    name: BusinessPerfMetric.PostAuthenticationUnexpectedBehavior,
    data: { ...data, business_target: platformConfig.BUSINESS_TARGET },
  });
}

export function sendPostAuthenticationTriggered(data: {
  restartCount: number;
  source?: LoginFromSource;
}) {
  monitor.sendAccumulate({
    name: BusinessPerfMetric.PostAuthenticationTriggered,
    data: { ...data, business_target: platformConfig.BUSINESS_TARGET },
  });
}
